import React from 'react';

/**
 * Input Component
 * Reusable form input with label and error message
 */
const Input = ({
  label,
  name,
  type = 'text',
  value,
  onChange,
  onBlur,
  placeholder,
  error,
  touched,
  required = false,
  disabled = false,
  icon,
  iconPosition = 'left',
  helper,
  className = '',
  inputClassName = '',
  ...props
}) => {
  const hasError = touched && error;
  const inputId = props.id || `input-${name}`;

  return (
    <div className={`mb-4 ${className}`}>
      {/* Label */}
      {label && (
        <label htmlFor={inputId} className="label">
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}

      {/* Input wrapper */}
      <div className="relative">
        {/* Left icon */}
        {icon && iconPosition === 'left' && (
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-bukawa-gray-400">
            {icon}
          </div>
        )}

        {/* Input field */}
        <input
          id={inputId}
          name={name}
          type={type}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={placeholder}
          disabled={disabled}
          required={required}
          className={`
            ${hasError ? 'input-error' : 'input'}
            ${icon && iconPosition === 'left' ? 'pl-10' : ''}
            ${icon && iconPosition === 'right' ? 'pr-10' : ''}
            ${disabled ? 'bg-bukawa-gray-100 cursor-not-allowed' : ''}
            ${inputClassName}
          `.trim().replace(/\s+/g, ' ')}
          aria-invalid={hasError ? 'true' : 'false'}
          aria-describedby={
            hasError ? `${inputId}-error` : helper ? `${inputId}-helper` : undefined
          }
          {...props}
        />

        {/* Right icon */}
        {icon && iconPosition === 'right' && (
          <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none text-bukawa-gray-400">
            {icon}
          </div>
        )}
      </div>

      {/* Helper text */}
      {helper && !hasError && (
        <p
          id={`${inputId}-helper`}
          className="mt-1 text-sm text-bukawa-gray-500"
        >
          {helper}
        </p>
      )}

      {/* Error message */}
      {hasError && (
        <p
          id={`${inputId}-error`}
          className="mt-1 text-sm text-red-600"
          role="alert"
        >
          {error}
        </p>
      )}
    </div>
  );
};

export default Input;